import {
  ApproveTicketTypeRequestRequest,
  RejectTicketTypeRequestRequest,
  SubmitTicketTypeRequestRequest,
  TicketTypeRequestsRequest,
} from '../api/requests';
import type { UserStore } from '~/authentication/stores/user';
import type ApiClient from '~/common/services/ApiClient';
import type { RequestPagination } from '~/common/types';
import type { TicketTypeRequestCreate, TicketTypeRequestID } from '../types';

export class TicketTypeRequestsService {
  apiClient: ApiClient;
  userStore: UserStore;

  constructor(apiClient: ApiClient, userStore: UserStore) {
    this.apiClient = apiClient;
    this.userStore = userStore;
  }

  async fetch(pagination: RequestPagination, params: Record<string, any>) {
    const accessToken = this.userStore.accessToken;
    const request = new TicketTypeRequestsRequest({
      token: accessToken,
      params: { ...pagination, ...params },
    });

    return this.apiClient.request(request);
  }

  async create(ticketTypeRequest: TicketTypeRequestCreate) {
    const accessToken = this.userStore.accessToken;
    const request = new SubmitTicketTypeRequestRequest({
      token: accessToken,
      ticketTypeRequest,
    });

    return this.apiClient.request(request);
  }

  async approve(id: TicketTypeRequestID) {
    const accessToken = this.userStore.accessToken;
    const request = new ApproveTicketTypeRequestRequest({
      token: accessToken,
      id,
    });

    return this.apiClient.request(request);
  }

  async reject(id: TicketTypeRequestID, rejectionReason: string) {
    const accessToken = this.userStore.accessToken;
    const request = new RejectTicketTypeRequestRequest({
      token: accessToken,
      id,
      ticketTypeRequest: { rejectionReason },
    });

    return this.apiClient.request(request);
  }
}
